import { paths } from '@perpay-web/fintech/props/appPaths';

export const UPDATE_DIRECT_DEPOSIT_CONTEXT = 'updateDirectDeposit';
export const CREDIT_LIMIT_INCREASE_CONTEXT = 'creditLimitIncrease';

export const UPDATE_DIRECT_DEPOSIT_PATHS_TO_CONTEXTS = {
    [paths.updateDirectDeposit.path]: UPDATE_DIRECT_DEPOSIT_CONTEXT,
    [paths.updateDirectDepositCreditLimit.path]: CREDIT_LIMIT_INCREASE_CONTEXT,
};
